var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75226 0.499512H11.2548C13.7973 0.499512 15.4998 2.28451 15.4998 4.93951V11.0678C15.4998 13.7153 13.7973 15.4995 11.2548 15.4995H4.75226C2.20976 15.4995 0.499756 13.7153 0.499756 11.0678V4.93951C0.499756 2.28451 2.20976 0.499512 4.75226 0.499512ZM7.99232 5.79528C7.63982 5.79528 7.34732 5.50203 7.34732 5.14278C7.34732 4.77527 7.63982 4.48277 8.00732 4.48277C8.36732 4.48277 8.65982 4.77527 8.65982 5.14278C8.65982 5.50203 8.36732 5.79528 7.99232 5.79528ZM8.65219 10.8353C8.65219 11.1953 8.35969 11.4878 7.99219 11.4878C7.63219 11.4878 7.33969 11.1953 7.33969 10.8353V7.52025C7.33969 7.1595 7.63219 6.86025 7.99219 6.86025C8.35969 6.86025 8.65219 7.1595 8.65219 7.52025V10.8353Z",
    fill: "#0A3400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.332d4014d422b69627efc073a2dc0f0d.svg";
export { ForwardRef as ReactComponent };